import React, {Component} from 'react'
import PropTypes from 'prop-types'

class DateColumn extends Component {
    render() {
        const {created, generated} = this.props
        const timeCreate = created ? new Date(created).toLocaleString('en-GB') : '';
        const timeGen = generated ? new Date(generated).toLocaleString('en-GB') : '';

        return <td className="Date">
            <span className="d-flex flex-column">
                {timeCreate && <span><span className="badge badge-mark border-success mr-1"/>{timeCreate}</span>}
                {timeGen && <span><span className="badge badge-mark border-primary mr-1"/>{timeGen}</span>}
            </span>
        </td>
    }
}

DateColumn.propTypes = {
    created: PropTypes.string,
    generated: PropTypes.string
}

export default DateColumn